/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetReportBookmarksParams,
  ReportBookmarkDto,
  ReportBookmarkRequest
} from '../schemas';

import { customAxios } from '../../orval-mutator';
import type { ErrorType , BodyType } from '../../orval-mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Authorities: **Any authenticated role**
 */
export const getReportBookmarkById = (
    oktaUserId: string,
    userId: number,
    id: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ReportBookmarkDto>(
      {url: `/api/${oktaUserId}/users/${userId}/report-bookmarks/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetReportBookmarkByIdQueryKey = (oktaUserId: string,
    userId: number,
    id: number,) => {
    return [
    `/api/${oktaUserId}/users/${userId}/report-bookmarks/${id}`
    ] as const;
    }


export const getGetReportBookmarkByIdQueryOptions = <TData = Awaited<ReturnType<typeof getReportBookmarkById>>, TError = ErrorType<unknown>>(oktaUserId: string,
    userId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportBookmarkById>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReportBookmarkByIdQueryKey(oktaUserId,userId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportBookmarkById>>> = ({ signal }) => getReportBookmarkById(oktaUserId,userId,id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: !!(oktaUserId && userId && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReportBookmarkById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReportBookmarkByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getReportBookmarkById>>>
export type GetReportBookmarkByIdQueryError = ErrorType<unknown>


export function useGetReportBookmarkById<TData = Awaited<ReturnType<typeof getReportBookmarkById>>, TError = ErrorType<unknown>>(
 oktaUserId: string,
    userId: number,
    id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportBookmarkById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportBookmarkById>>,
          TError,
          Awaited<ReturnType<typeof getReportBookmarkById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportBookmarkById<TData = Awaited<ReturnType<typeof getReportBookmarkById>>, TError = ErrorType<unknown>>(
 oktaUserId: string,
    userId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportBookmarkById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportBookmarkById>>,
          TError,
          Awaited<ReturnType<typeof getReportBookmarkById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportBookmarkById<TData = Awaited<ReturnType<typeof getReportBookmarkById>>, TError = ErrorType<unknown>>(
 oktaUserId: string,
    userId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportBookmarkById>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetReportBookmarkById<TData = Awaited<ReturnType<typeof getReportBookmarkById>>, TError = ErrorType<unknown>>(
 oktaUserId: string,
    userId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportBookmarkById>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetReportBookmarkByIdQueryOptions(oktaUserId,userId,id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * Authorities: **Any authenticated role**
 */
export const updateReportBookmark = (
    oktaUserId: string,
    userId: number,
    id: number,
    reportBookmarkRequest: BodyType<ReportBookmarkRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ReportBookmarkDto>(
      {url: `/api/${oktaUserId}/users/${userId}/report-bookmarks/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: reportBookmarkRequest, signal
    },
      options);
    }



export const getUpdateReportBookmarkMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateReportBookmark>>, TError,{oktaUserId: string;userId: number;id: number;data: BodyType<ReportBookmarkRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof updateReportBookmark>>, TError,{oktaUserId: string;userId: number;id: number;data: BodyType<ReportBookmarkRequest>}, TContext> => {

const mutationKey = ['updateReportBookmark'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateReportBookmark>>, {oktaUserId: string;userId: number;id: number;data: BodyType<ReportBookmarkRequest>}> = (props) => {
          const {oktaUserId,userId,id,data} = props ?? {};

          return  updateReportBookmark(oktaUserId,userId,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateReportBookmarkMutationResult = NonNullable<Awaited<ReturnType<typeof updateReportBookmark>>>
    export type UpdateReportBookmarkMutationBody = BodyType<ReportBookmarkRequest>
    export type UpdateReportBookmarkMutationError = ErrorType<unknown>

    export const useUpdateReportBookmark = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateReportBookmark>>, TError,{oktaUserId: string;userId: number;id: number;data: BodyType<ReportBookmarkRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateReportBookmark>>,
        TError,
        {oktaUserId: string;userId: number;id: number;data: BodyType<ReportBookmarkRequest>},
        TContext
      > => {
      return useMutation(getUpdateReportBookmarkMutationOptions(options), queryClient);
    }
    /**
 * Authorities: **Any authenticated role**
 */
export const deleteReportBookmark = (
    oktaUserId: string,
    userId: number,
    id: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/${oktaUserId}/users/${userId}/report-bookmarks/${id}`, method: 'DELETE', signal
    },
      options);
    }



export const getDeleteReportBookmarkMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteReportBookmark>>, TError,{oktaUserId: string;userId: number;id: number}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteReportBookmark>>, TError,{oktaUserId: string;userId: number;id: number}, TContext> => {

const mutationKey = ['deleteReportBookmark'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteReportBookmark>>, {oktaUserId: string;userId: number;id: number}> = (props) => {
          const {oktaUserId,userId,id} = props ?? {};

          return  deleteReportBookmark(oktaUserId,userId,id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteReportBookmarkMutationResult = NonNullable<Awaited<ReturnType<typeof deleteReportBookmark>>>

    export type DeleteReportBookmarkMutationError = ErrorType<unknown>

    export const useDeleteReportBookmark = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteReportBookmark>>, TError,{oktaUserId: string;userId: number;id: number}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteReportBookmark>>,
        TError,
        {oktaUserId: string;userId: number;id: number},
        TContext
      > => {
      return useMutation(getDeleteReportBookmarkMutationOptions(options), queryClient);
    }
    /**
 * Authorities: **Any authenticated role**
 */
export const getReportBookmarks = (
    oktaUserId: string,
    userId: number,
    params?: GetReportBookmarksParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ReportBookmarkDto[]>(
      {url: `/api/${oktaUserId}/users/${userId}/report-bookmarks`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetReportBookmarksQueryKey = (oktaUserId: string,
    userId: number,
    params?: GetReportBookmarksParams,) => {
    return [
    `/api/${oktaUserId}/users/${userId}/report-bookmarks`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetReportBookmarksQueryOptions = <TData = Awaited<ReturnType<typeof getReportBookmarks>>, TError = ErrorType<unknown>>(oktaUserId: string,
    userId: number,
    params?: GetReportBookmarksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportBookmarks>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReportBookmarksQueryKey(oktaUserId,userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportBookmarks>>> = ({ signal }) => getReportBookmarks(oktaUserId,userId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: !!(oktaUserId && userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReportBookmarks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReportBookmarksQueryResult = NonNullable<Awaited<ReturnType<typeof getReportBookmarks>>>
export type GetReportBookmarksQueryError = ErrorType<unknown>


export function useGetReportBookmarks<TData = Awaited<ReturnType<typeof getReportBookmarks>>, TError = ErrorType<unknown>>(
 oktaUserId: string,
    userId: number,
    params: undefined |  GetReportBookmarksParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportBookmarks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportBookmarks>>,
          TError,
          Awaited<ReturnType<typeof getReportBookmarks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportBookmarks<TData = Awaited<ReturnType<typeof getReportBookmarks>>, TError = ErrorType<unknown>>(
 oktaUserId: string,
    userId: number,
    params?: GetReportBookmarksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportBookmarks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportBookmarks>>,
          TError,
          Awaited<ReturnType<typeof getReportBookmarks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportBookmarks<TData = Awaited<ReturnType<typeof getReportBookmarks>>, TError = ErrorType<unknown>>(
 oktaUserId: string,
    userId: number,
    params?: GetReportBookmarksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportBookmarks>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetReportBookmarks<TData = Awaited<ReturnType<typeof getReportBookmarks>>, TError = ErrorType<unknown>>(
 oktaUserId: string,
    userId: number,
    params?: GetReportBookmarksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportBookmarks>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetReportBookmarksQueryOptions(oktaUserId,userId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * Authorities: **Any authenticated role**
 */
export const createReportBookmark = (
    oktaUserId: string,
    userId: number,
    reportBookmarkRequest: BodyType<ReportBookmarkRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ReportBookmarkDto>(
      {url: `/api/${oktaUserId}/users/${userId}/report-bookmarks`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: reportBookmarkRequest, signal
    },
      options);
    }



export const getCreateReportBookmarkMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createReportBookmark>>, TError,{oktaUserId: string;userId: number;data: BodyType<ReportBookmarkRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof createReportBookmark>>, TError,{oktaUserId: string;userId: number;data: BodyType<ReportBookmarkRequest>}, TContext> => {

const mutationKey = ['createReportBookmark'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createReportBookmark>>, {oktaUserId: string;userId: number;data: BodyType<ReportBookmarkRequest>}> = (props) => {
          const {oktaUserId,userId,data} = props ?? {};

          return  createReportBookmark(oktaUserId,userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateReportBookmarkMutationResult = NonNullable<Awaited<ReturnType<typeof createReportBookmark>>>
    export type CreateReportBookmarkMutationBody = BodyType<ReportBookmarkRequest>
    export type CreateReportBookmarkMutationError = ErrorType<unknown>

    export const useCreateReportBookmark = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createReportBookmark>>, TError,{oktaUserId: string;userId: number;data: BodyType<ReportBookmarkRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createReportBookmark>>,
        TError,
        {oktaUserId: string;userId: number;data: BodyType<ReportBookmarkRequest>},
        TContext
      > => {
      return useMutation(getCreateReportBookmarkMutationOptions(options), queryClient);
    }
